import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import AssessmentScore from 'components/common/AssessmentScore';
import { Student } from 'types';
import { Typography } from '@mui/material';

const StudentList = (props: {
  score: number;
  studentIds: number[];
  students: Student[];
  showNumberedList: boolean;
}): React.ReactElement => {
  // eslint-disable-next-line
  const classes = useStyles();

  const getName = (studentId: number) => {
    const student = props.students.find((student) => student.id === studentId)!;
    return `${student.firstName} ${student.lastName}`;
  };

  return (
    <List style={{ width: '100%' }}>
      <ListItem>
        <AssessmentScore score={props.score === 0 ? null : props.score} showLabel={true} />
        {!props.showNumberedList && <Typography>&nbsp;- {props.studentIds.length}</Typography>}
      </ListItem>
      <Divider className={classes.grayLine} />
      {props.studentIds.map((studentId, index) => (
        <ListItem key={studentId}>
          <ListItemText
            primary={(props.showNumberedList ? index + 1 + '. ' : '') + getName(studentId)}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default StudentList;

const useStyles = makeStyles((theme: Theme) => {
  return {
    sectionHeader: {
      color: theme.palette.primary.main,
    },
    grayLine: {
      height: '1px !important',
      backgroundColor: '#EAEAEA !important',
      width: '100%',
    },
  };
});
